import { h } from 'preact';
import { HeaderV2 } from '@cube/blocks';
import style from './style';
import { Text } from 'preact-i18n';
import cx from 'classnames';

export const QuoteHeader = ({ width, enableHeader=true, ...props }) => {
	const WIDTH_BREAKPOINT = 500;
	return (
		width >= WIDTH_BREAKPOINT ?
			<div class={cx(style.quoteLookup)}>
				{enableHeader && <HeaderV2 class={cx(style.header, width >= 768 && style.wide)} title={<Text id="quote-header.quoteLookup">Quote Lookup</Text>} />}
				<p class={cx(style.lastUpdated, enableHeader && style.padTop)}>
					<Text id="QUOTES_DELAYED">Quotes delayed at least 15min.</Text>
					<a href={`/finance/disclaimer`} target="_blank" rel="noopener noreferrer">
						<Text id="DISCLAIMER">Disclaimer</Text>
					</a>
				</p>
			</div>
			: null
	);
};
